import React, { useEffect, useState } from "react"

import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap"
// Formik validation
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../../components/ResultHandler"
import { editFee, getFee } from "../../../../api/fee"
import FormButtonHandler from "../../../../components/FormButtonHandler"
import useCustomValidation from "../../validationSchema"
import { useResponse } from "../../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../../hooks/useGetInstence"
import FeeForm from "./FeeForm"
import FIELDS from "./CONSTANT"
import * as Yup from "yup"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

FIELDS.forEach(f => {
    initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "" 
    if(f.type == 'file'){
        FIELDS_VALIDATION[f.key+"_preview"] = Yup.string().required("This Field Is Required")

    }else{
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required")
    }
})

const EditFee = () => {
    let navigate = useHistory()
    const { feeSchema } = useCustomValidation()

    const { t } = useTranslation()

    const params = useParams()
    const [editedFee, setEditedFee] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getFee,
        params.feeId,
        response => {
            setEditedFee({
                ...response.data.data.companyFee,
            })
        }
    )

    const { setData, loading, error, success } = useResponse(editFee, () => {
        navigate.goBack()
    })

    // Form validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            ...editedFee,
            _function: editedFee?.function || ""
        },
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: data => {
           
            setData({ type: "edit", id: params.feeId, data })
        },
    })



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Fees")}
                        breadcrumbItem={t("btns.Edit") + " " + t("Fee")}
                    />
                    
                        {editedFee && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <FeeForm validation={validation} />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>


                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditFee